module.exports = __webpack_public_path__ + "static/media/image-fifth-strip.ff8fd900.svg";